import { useGraphQLQuery } from '@betterment/graphql';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { EnvelopeAccountTaxationTypesDocument } from './graphql/query.envelopeAccountTaxationTypes.generated';
import { IraContributionOverviewCard } from './IraContributionOverviewCard/IraContributionOverviewCard';

import { LegalAccountTaxationType } from '../../../graphql/schema';
import { ENVELOPE_ACCOUNT_MANAGED_TYPE } from '../../../Shared/constants';

export const IraContributionsCard: React.FC = () => {
  const accountId = useRequiredParam('accountId');
  const { data, loading } = useGraphQLQuery(EnvelopeAccountTaxationTypesDocument, { variables: { id: accountId } });

  if (!data || loading) return null;
  if (data.envelopeAccount.__typename !== ENVELOPE_ACCOUNT_MANAGED_TYPE) return null;

  const iraTypes = new Set([LegalAccountTaxationType.RothIra, LegalAccountTaxationType.TraditionalIra]);
  const taxationTypes = data.envelopeAccount.subAccounts.map(sa => sa.legalAccount.taxationType);

  if (!taxationTypes.some(t => iraTypes.has(t))) return null;

  return <IraContributionOverviewCard />;
};
